import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectCompSequence } from './orderSelectors.ts';
import {
  selectTransactionById,
  selectTransactionEntities,
} from './propertyDataSelectors/transactionSelectors.ts';
import { selectImprovementsCost, selectImprovementsCosts } from './selectImprovementsCost.ts';

const calculateUnadjustedSiteCost = (
  transaction: ReturnType<typeof selectTransactionById>,
  depreciatedCostOfImprovements: ReturnType<typeof selectImprovementsCost>,
) => {
  if (isUndefined(transaction) || isUndefined(depreciatedCostOfImprovements)) {
    return undefined;
  }

  const price = AloftPrice.schema.safeParse(transaction.price);
  return price.success ? price.data.sub(depreciatedCostOfImprovements) : undefined;
};

export const selectUnadjustedSiteCost = createSelector(
  [selectTransactionById, selectImprovementsCost],
  calculateUnadjustedSiteCost,
);

export const selectUnadjustedSiteCosts = createSelector(
  [selectTransactionEntities, selectImprovementsCosts, selectCompSequence],
  (transactions, unadjustedSiteCosts, compSequence) => {
    const properties = ['subject', ...compSequence];

    return Object.fromEntries(
      properties.map((propID) => [
        propID,
        calculateUnadjustedSiteCost(transactions[propID], unadjustedSiteCosts[propID]),
      ]),
    );
  },
);

export const selectUnadjustedSiteCostDisplay = createSelector(
  [selectUnadjustedSiteCost],
  (siteCost) => siteCost?.toString(true),
);
